import {
  JsonApiMappedUser,
  ProfileFieldsetCompletionSection,
  ProfileFieldsCompletion,
  ProfileType,
} from '../../@types/jsonapi.d';
import { getProfileStatus, getStudentPublicationStatus } from '../profile';
import { getUserMainProfile } from '../user';

export function getUserFieldsetCompletionPercentage(
  user: JsonApiMappedUser,
  fieldsetName: ProfileFieldsetCompletionSection,
): number {
  const profile = getUserMainProfile(user);
  return profile?.profileCompletion?.fieldsets?.[fieldsetName]?.completionPercentage || 0;
}

export function isNewFieldForUser(
  user: JsonApiMappedUser,
  fieldsetName: ProfileFieldsetCompletionSection,
): boolean {
  const profile = getUserMainProfile(user);
  return profile?.profileCompletion?.fieldsets?.[fieldsetName]?.newField || false;
}

export function isNewSectionForUser(
  user: JsonApiMappedUser,
  fieldsetName: ProfileFieldsetCompletionSection,
): boolean {
  const profile = getUserMainProfile(user);
  return profile?.profileCompletion?.fieldsets?.[fieldsetName]?.newSection || false;
}

export function isFieldCompletedOnServer(
  user: JsonApiMappedUser,
  fieldsetName: ProfileFieldsCompletion,
) {
  const profile = getUserMainProfile(user);
  return profile?.profileCompletion?.fields?.[fieldsetName]?.complete;
}

export function isFieldsetInSuccess(
  user: JsonApiMappedUser,
  fieldsetName: ProfileFieldsetCompletionSection,
): boolean {
  const mainProfile = getUserMainProfile(user);
  return mainProfile?.profileCompletion?.fieldsets?.[fieldsetName]?.complete || false;
}

export function isIntershipComplete(
  user: JsonApiMappedUser,
) {
  const mainProfile = getUserMainProfile(user);
  const internships = mainProfile?.internships;
  if (Array.isArray(internships)) {
    return internships.length > 0;
  }
  return false;
}

export function isAffiliatedToAssignment(
  user?: JsonApiMappedUser,
): boolean {
  if (!user) {
    return false;
  }
  const mainProfile = getUserMainProfile(user);
  return mainProfile?.affiliatedToSchoolAssignment || false;
}

export function isSoftDeletedUser(user?: JsonApiMappedUser): boolean {
  const userProfile = getUserMainProfile(user);
  if ([
    ProfileType.mentor,
    ProfileType.employee,
  ].includes(userProfile.type)) {
    return getProfileStatus(userProfile) === 'softDeleted';
  }
  if (userProfile.type === ProfileType.student) {
    return getStudentPublicationStatus(user) === 'softDeleted';
  }
  return false;
}
